import { useMemo } from "react"
import {
  useLazyGetBankNameQuery,
  useLazyGetPaymentModeQuery,
  useLazyGetValidateReferenceNumberQuery,
  useFractionalProcessingFeesMutation,
} from "features/leads/api"

export function useFractionalSalePaymentApis() {
  const [getBankName, banksQuery] = useLazyGetBankNameQuery()
  const [getPaymentMode, paymentModeQuery] = useLazyGetPaymentModeQuery()
  const [validateReference, referenceQuery] = useLazyGetValidateReferenceNumberQuery()
  const [
    fractionalProcessingFees,
    {
      data: psidFeeData,
      isLoading: loadingPsidProcessingFees,
      isSuccess: psidFeesFetchSuccess,
      isError: psidFeesError,
    },
  ] = useFractionalProcessingFeesMutation()

  return useMemo(
    () => ({
      getBankName,
      getPaymentMode,
      validateReference,
      banks: banksQuery.data,
      paymentMode: paymentModeQuery.data,
      isLoadingPaymentMode: paymentModeQuery.isFetching,
      referenceError: referenceQuery.isError,
      referenceValidity: referenceQuery.data,
      fractionalProcessingFees,
      psidFeeData,
      loadingPsidProcessingFees,
      psidFeesFetchSuccess,
      psidFeesError,
    }),
    [
      getBankName,
      getPaymentMode,
      validateReference,
      banksQuery.data,
      banksQuery.isFetching,
      paymentModeQuery.data,
      paymentModeQuery.isFetching,
      referenceQuery.isError,
      referenceQuery.data,
      fractionalProcessingFees,
      psidFeeData,
      loadingPsidProcessingFees,
      psidFeesFetchSuccess,
      psidFeesError,
    ]
  )
}
